import { render, staticRenderFns } from "./SwiperCmp.vue?vue&type=template&id=72e64c55&"
import script from "./SwiperCmp.vue?vue&type=script&lang=js&"
export * from "./SwiperCmp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports